import * as Generated from '../../../generated/graphql';
import {type ThunkResult} from '../../../types/redux';
import {parseUser} from '../api';
import * as DiscussionCommentActions from './actions';
import {type Ref as DiscussionCommentRef} from './types';

export function updateReportDiscussionComment(
  discussionCommentRef: DiscussionCommentRef,
  body: string,
  viewID?: string,
  callback?: () => void
): ThunkResult<void> {
  return (dispatch, getState, client) => {
    const state = getState();
    const commentServerID =
      state.views.parts[discussionCommentRef.type][discussionCommentRef.id].id;

    client
      .mutate<Generated.UpdateDiscussionCommentMutation>({
        mutation: Generated.UpdateDiscussionCommentDocument,
        variables: {
          viewID,
          discussionCommentID: commentServerID,
          body,
        },
        refetchQueries: [],
      })
      .then(response => {
        const updatedComment =
          response.data?.updateDiscussionComment?.discussionComment;
        if (updatedComment != null) {
          dispatch(
            DiscussionCommentActions.updateDiscussionComment(
              discussionCommentRef,
              {
                ...updatedComment,
                poster: parseUser(updatedComment.poster!),
                updatedAt: updatedComment.updatedAt ?? undefined,
              }
            )
          );
          if (callback != null) {
            // https://oxc.rs/docs/guide/usage/linter/rules/promise/no-callback-in-promise.html#why-is-this-bad
            // oxlint-disable-next-line promise/no-callback-in-promise
            callback();
          }
        }
      });
  };
}
